export const PROJECTS = [
  {
    id: "jlizandco",
    name: "J’Liz & Company",
    type: "Website",
    url: "https://jlizandco.com",
    domain: "jlizandco.com",
    image: "/assets/work_jlizandco.jpg",
    summary: "A Huntsville boutique site for J Dolls and Hair Haven, where shoppers reserve pieces online and pay at pickup.",
    tags: ["Boutique", "Online reservations", "Huntsville, AL"],
  },
  {
    id: "i65ryders",
    name: "I-65 Ryders",
    type: "Website",
    url: "https://i65ryders.com",
    domain: "i65ryders.com",
    image: "/assets/work_i65ryders.jpg",
    summary: "The official home of a riding club covering ATVs, horses, side-by-sides, motorcycles and custom trucks, with events, tickets, a shop and member sign-up.",
    tags: ["Riding club", "Events & tickets", "Shop"],
  },
  {
    id: "triohsv",
    name: "Trio",
    type: "Website",
    url: "https://triohsv.com",
    domain: "triohsv.com",
    image: "/assets/work_triohsv.jpg",
    summary: "A soul food restaurant, bar and lounge site with specials, the full menu, reservations, a VIP room, careers and DoorDash delivery.",
    tags: ["Restaurant & lounge", "Reservations", "Huntsville, AL"],
  },
];
